/* eslint-disable */
import { useRef, useEffect, useState, Children } from 'react'
import { motion, useMotionValue, useAnimation } from 'framer-motion'
import { useSelector, useDispatch } from 'react-redux'
import { annotateTrackWithPrice } from 'modules/price/selectors'
import CoverArt from 'components/coverart'
import { useActions } from 'modules/audio/hooks'
import { createSongItemId } from 'utils'
import PlayButton from 'components/playbutton'
import { actions as audioActions } from 'modules/audio/actions'

import styles from './tinder.css'

export const Card = ({ children, style, onVote, id, ...props }) => {
  // motion stuff
  const cardElem = useRef(null)

  const x = useMotionValue(0)
  const controls = useAnimation()

  const [constrained, setConstrained] = useState(true)

  const [direction, setDirection] = useState()

  const [velocity, setVelocity] = useState()

  const getVote = (childNode, parentNode) => {
    const childRect = childNode.getBoundingClientRect()
    const parentRect = parentNode.getBoundingClientRect()
    let result = parentRect.left >= childRect.right ? false : parentRect.right <= childRect.left ? true : undefined
    return result
  }

  // determine direction of swipe based on velocity
  const getDirection = () => {
    return velocity >= 1 ? 'right' : velocity <= -1 ? 'left' : undefined
  }

  const getTrajectory = () => {
    setVelocity(x.getVelocity())
    setDirection(getDirection())
  }

  const flyAway = min => {
    const flyAwayDistance = direction => {
      const parentWidth = cardElem.current.parentNode.getBoundingClientRect().width
      const childWidth = cardElem.current.getBoundingClientRect().width
      return direction === 'left' ? -parentWidth / 2 - childWidth / 2 : parentWidth / 2 + childWidth / 2
    }

    if (direction && Math.abs(velocity) > min) {
      setConstrained(false)
      controls.start({
        x: flyAwayDistance(direction),
      })
    }
  }

  useEffect(() => {
    const unsubscribeX = x.onChange(() => {
      const childNode = cardElem.current
      const parentNode = cardElem.current.parentNode
      const result = getVote(childNode, parentNode)
      result !== undefined && onVote(result)
    })

    return () => unsubscribeX()
  })

  return (
    <motion.div
      className={styles.styledCard}
      animate={controls}
      dragConstraints={constrained && { left: 0, right: 0, top: 0, bottom: 0 }}
      dragElastic={1}
      ref={cardElem}
      style={{ x }}
      onDrag={getTrajectory}
      onDragEnd={() => flyAway(500)}
      whileTap={{ scale: 1.1 }}
      {...props}
    >
      {children}
    </motion.div>
  )
}

export const Stack = ({ onVote, children, ...props }) => {
  const dispatch = useDispatch()
  const [stack, setStack] = useState(Children.toArray(children))

  // return new array with last item removed
  const pop = array => {
    return array.filter((_, index) => {
      return index < array.length - 1
    })
  }

  const handleVote = (item, vote) => {
    // update the stack
    let newStack = pop(stack)
    setStack(newStack)

    // run function from onVote prop, passing the current item and value of vote
    onVote(item, vote)

    return dispatch(audioActions.skip(true))
  }

  return (
    <>
      <div className={styles.wrapper} {...props}>
        {stack.map((item, index) => {
          let isTop = index === stack.length - 1
          return (
            <Card
              drag={isTop} // Only top card is draggable
              key={item.key || index}
              onVote={result => handleVote(item, result)}
            >
              {item}
            </Card>
          )
        })}
      </div>
    </>
  )
}

const Item = ({ children }) => (
  <div className={styles.item} style={{ transform: `rotate(${Math.random() * (5 - -5) + -5}deg)` }}>
    {children}
  </div>
)

const Tinder = ({ trackListProps }) => {
  const state = useSelector(s => s)
  const { handleAddToFavorites } = useActions()

  const handleVote = (id, vote) => {
    if (vote) {
      handleAddToFavorites(+id)
    }
  }
  const reversed = [...trackListProps.trackIds].reverse()
  if (trackListProps.request.isDone) {
    return (
      <div className={styles.wrap}>
        <Stack onVote={(item, vote) => handleVote(item.props.id, vote)}>
          {reversed.map(t => {
            const trackId = t.id
            const track = annotateTrackWithPrice(state, state.entities.tracks[String(trackId)])
            const song = state.entities.songs[String(track?.song)]
            const songItemId = createSongItemId(trackId, null)
            return (
              <Item data-value={trackId} whileTap={{ scale: 1.15 }} id={trackId}>
                <CoverArt cover={song.cover} className={styles.cover} sizes="450px" />
                <div className={styles.butt}>
                  <PlayButton
                    entity="track"
                    value={{ songItemId, trackId }}
                    datatesting="songitemplaybutton"
                    contextKey={trackListProps.contextKey}
                  />
                </div>
                {song.title}
              </Item>
            )
          })}
        </Stack>
      </div>
    )
  }

  return <></>
}

export default Tinder
